<template>
  <div id="matterDetail">
    <div class="service-container">
      <h4>{{ detail.SXMC }}</h4>
      <ul>
        <li><span>事项编号：{{ detail.SXBH }}</span></li>
        <li><span>编制部门：{{ detail.BZDWMC? BZDWMC : '不详' }}</span></li>
        <li><span>编<em>制</em>人: {{ detail.BZR }}</span></li>
<!--    TODO: 阅读量后期优化    -->
<!--        <li><span>阅<em>读</em>量: 0次</span></li>-->
        <li><span>编制日期：{{ detail.BZRQ }}</span></li>
      </ul>
      <p>受理机构：{{ detail.SLDW }}</p>
      <p>岗位/责任人：{{ detail.SLJGGW }}</p>
      <p>办件类型：{{ detail.XXBJLX }}</p>
      <p>办理模式：{{ detail.BJMS }}</p>
      <p>办件对象：{{ detail.FWDX }}</p>
      <p>承诺期限：{{ detail.CNQX }}</p>
      <p>事项性质：{{ detail.SXXZ }}</p>
      <p>现场办理次数：{{ detail.QXCCS }}</p>
      <p>受理地点：{{ detail.SLDD }}</p>
      <p>受理时间：{{ detail.XXYWSL }}</p>
      <p>咨询电话：{{ detail.ZXDH }}</p>
      <p>监督电话：{{ detail.JDJG }}</p>
      <!--   button   -->
<!--      <div class="service-btn-box">-->
<!--        <van-button block>申请</van-button>-->
<!--      </div>-->
    </div>
    <div class="base-info service-info">
      <h4>办事流程</h4>
      <p>{{ detail.BLLC }}</p>
    </div>
    <div class="base-info service-info">
      <h4>申请材料及表格下载</h4>
      <h5>一、申请材料</h5>
      <p
        v-for="(item, index) in detail.SQCL_list"
        :key="index"
        @click="onPreviewFile(item.type, item.url)"
      >{{ index+1 }}、{{ item.SQCLNR }}</p>
      <h5>二、申请材料</h5>
      <p
          v-for="(item, index) in detail.SQCL_list"
          :key="index"
          @click="onPreviewFile(item.type, item.url)"
      >{{ index+1 }}、{{ item.SQCLNR }}</p>
    </div>
    <div class="base-info service-info" v-if="detail.BSYJ_list">
      <h4>办事依据</h4>
      <p
        v-for="(item, index) in detail.BSYJ_list"
        :key="index"
      >{{ index+1 }}、{{ item.FLZCXGWJ }}</p>
    </div>
    <div class="base-info service-info" v-if="detail.CJWT_list">
      <h4>常见问题</h4>
      <p
          v-for="(item, index) in detail.CJWT_list"
          :key="index"
      >
        <span class="block">{{ index+1 }}、问题</span>
        <span class="block"><em class="size-em"></em>{{ item.YCXCJWT }}</span>
        <span class="block">解答：</span>
        <span class="block"><em class="size-em"></em>{{ item.CJWTJD }}</span>
      </p>
    </div>
    <div class="service-info" v-if="detail.SLJG_list">
      <h4>受理结果示范文本</h4>
      <p
          v-for="(item, index) in detail.SLJG_list"
          :key="index"
      >{{ index+1 }}、{{ item.SLJGSFWB }}</p>
    </div>
    <div class="service-info" v-if="detail.QZTJ_list">
      <h4>前置条件</h4>
      <p
          v-for="(item, index) in detail.QZTJ_list"
          :key="index"
      >{{ index+1 }}、{{ item.SLJGSFWB }}</p>
    </div>
  </div>
</template>

<script>
import { queryMobileItemListDetail } from '@/api/three-list/index'
import {baseURL, complete} from "@/utils/url"
import {FILE_TYPE_IMAGE, parseFileType, previewFile, previewImage} from "@/utils/file";
export default {
  name: "MatterDetail",
  data() {
    return {
      baseURL: baseURL,
      id: this.$route.query.id,
      detail: {}
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      queryMobileItemListDetail({itemId: this.id}).then(res => {
        if(res.code && res.code == 200) {
          this.detail = res.data;
          document.title = res.data.SXMC;
        } else {
          document.title = '详情';
        }
      })
    },
    onPreviewFile(fileType, downloadUrl) {
      if (parseFileType(fileType.toLowerCase()) === FILE_TYPE_IMAGE) {
        previewImage([complete(downloadUrl)]);
      } else {
        previewFile(parseFileType(fileType.toLowerCase()), downloadUrl)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/theme/theme.scss";
.service-container, .service-info {
  padding: 15px;
  margin: 15px;
  background: #fff;
  border-radius: 5px;
  position: relative;

  .text-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  h4 {
    line-height: 38px;
    margin-right: 35px;
    font-weight: 500;
    color: $c333;
    @extend .font18;
  }
  h5 {
    height: 28px;
    line-height: 28px;
    font-weight: 500;
    color: $c333;
    @extend .font16;
  }
  h6 {
    height: 28px;
    line-height: 28px;
    font-weight: 500;
    @extend .font13;

    em {
      display: inline-block;
      width: 2em;
    }
  }
  ul{
    display: flex;
    flex-wrap: wrap;
    li{
      display: inline-flex;
      width: 50%;
      height: 25px;
      line-height: 25px;
      box-sizing: border-box;
      @extend .font13;
      @extend .color999;
      span{
        display: inline-block;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        em{
          display: inline-block;
          width: 2em;
          text-align: center;
        }
      }
      &:nth-child(2n+1) {
        padding-right:8px;
      }
      &:nth-child(2n) {
        padding-left: 8px;
      }
    }
  }
  p {
    height: 27px;
    line-height: 27px;
    color: $c333;
    @extend .font14;
    span.block{
      display: block;
      .size-em{
        display: inline-block;
        width: 2em;
      }
    }
  }

  .service-btn-box {
    max-height: 108px;
    overflow: hidden;
    margin-top: 20px;

    button {
      height: 42px;
      line-height: 42px;
      background: var(--main-color);
      color: #fff;
      border: none;
      border-radius: 5px;
      margin-bottom: 12px;
      @extend .font16;
      span{
        display: block;
        height: 42px;
        line-height: 42px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    &.height-auto {
      max-height: inherit;
    }
  }
}
</style>